import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../pages/dashboard/DashboardLayout';
import OverviewTab from '../pages/dashboard/OverviewTab';
import MenuTab from '../pages/dashboard/MenuTab';
import TablesTab from '../pages/dashboard/TablesTab';
import BaristasTab from '../pages/dashboard/BaristasTab';
import OrdersTab from '../pages/dashboard/OrdersTab';
import PostsTab from '../pages/dashboard/PostsTab';
import BillingTab from '../pages/dashboard/BillingTab';
import AnalyticsTab from '../pages/dashboard/AnalyticsTab';
import ProfileTab from '../pages/dashboard/ProfileTab';
import SettingsTab from '../pages/dashboard/SettingsTab';
import MenuCustomization from '../components/MenuCustomization';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useShop as useShopCtx } from '../context/ShopContext';

// Temporary: reuse createProduct & state from context via props injection within layout consumer later if needed.

const DashboardRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<OverviewTab
          onNavigateMenu={() => window.dispatchEvent(new CustomEvent('dashboard-switch-tab', { detail: { tab: 'menu' } }))}
          onNavigateTables={() => window.dispatchEvent(new CustomEvent('dashboard-switch-tab', { detail: { tab: 'tables' } }))}
          onNavigateBaristas={() => window.dispatchEvent(new CustomEvent('dashboard-switch-tab', { detail: { tab: 'baristas' } }))}
          onNavigateOrders={() => window.dispatchEvent(new CustomEvent('dashboard-switch-tab', { detail: { tab: 'orders' } }))}
          onViewPublicMenu={() => { /* handled inside old dashboard logic; will adjust later */ }}
        />} />
        <Route path="menu" element={<MenuWrapper />} />
  <Route path="profile" element={<ProfileTab />} />
        {/* Placeholder routes for yet-to-extract tabs */}
  <Route path="tables" element={<TablesTab />} />
  <Route path="baristas" element={<BaristasTab />} />
  <Route path="orders" element={<OrdersTab />} />
  <Route path="posts" element={<PostsTab />} />
  <Route path="billing" element={<BillingTab />} />
  <Route path="analytics" element={<AnalyticsTab />} />
  <Route path="settings" element={<SettingsTab />} />
      </Route>
    </Routes>
  );
};

// Legacy placeholder route artifacts fully removed during modular extraction

// Wrapper to inject createProduct and customization modal dependency until extracted fully.

const MenuWrapper = () => {
  const { t } = useTranslation();
  const { createProduct } = useShopCtx();
  const [showMenuCustomization, setShowMenuCustomization] = useState(false);
  return (
    <>
      <MenuTab
        createProduct={createProduct}
        t={t}
        setShowMenuCustomization={setShowMenuCustomization}
        showMenuCustomization={showMenuCustomization}
        MenuCustomization={MenuCustomization}
      />
      {showMenuCustomization && <MenuCustomization onClose={() => setShowMenuCustomization(false)} />}
    </>
  );
};

export default DashboardRoutes;
